<template>
  <div :class="['vuetable-pagination-info', $_css.infoClass]"
    v-html="paginationInfo">
  </div>
</template>

<script>
import PaginationInfoMixin from './VuetablePaginationInfoMixin.vue'

export default {
  mixins: [PaginationInfoMixin],
}
</script>
<style>
  .vuetable-pagination-info {
    margin-top: auto;
    margin-bottom: auto;
  }
</style>




// WEBPACK FOOTER //
// node_modules/vuetable-2/src/components/VuetablePaginationInfo.vue